import {
  REQUEST_TRIPS,
  RECEIVE_TRIPS,
  REQUEST_RELATED_TRIPS,
  RECEIVE_RELATED_TRIPS,
  REQUEST_ADDITIONAL_TRIPS,
  RECEIVE_ADDITIONAL_TRIPS,
  SET_TRIPS_OFFSET,
  SET_ACTIVE_TRIP_POPUP,
  TOGGLE_ACTIVE_TRIP_POPUP,
  SET_TRIP_VEHICLE_FILTER,
  SET_TRIP_SORT_FILTER,
  TOGGLE_SHOW_ALL_TRIPS,
  RECEIVE_FEATURED_PROMOS,
  RECEIVE_HOMEPAGE_BANNERS,
  TOGGLE_SELECT_BYOR
} from '../constants/actionTypes';

import { receiveErrorResponse } from './api';

import { INITIAL_NUM_TRIPS } from '../constants';

import { shuffle } from '../js/utility';

import api from '../api';
import { fakeTripApi3 } from '../constants/fakeTrips';

export const requestTrips = () => ({
  type: REQUEST_TRIPS
});

export const receiveTrips = (trips, total) => ({
  type: RECEIVE_TRIPS,
  trips,
  total
});

export const receiveFeaturedPromos = featuredPromos => ({
  type: RECEIVE_FEATURED_PROMOS,
  featuredPromos
});

export const receiveHomepageBanners = homepageBanners => ({
  type: RECEIVE_HOMEPAGE_BANNERS,
  homepageBanners
});

export const requestRelatedTrips = () => ({
  type: REQUEST_RELATED_TRIPS
});

export const receiveRelatedTrips = trips => ({
  type: RECEIVE_RELATED_TRIPS,
  trips
});

export const requestAdditionalTrips = () => ({
  type: REQUEST_ADDITIONAL_TRIPS
});

export const receiveAdditionalTrips = (trips, total) => ({
  type: RECEIVE_ADDITIONAL_TRIPS,
  trips,
  total
});

export const setTripsOffset = offset => ({
  type: SET_TRIPS_OFFSET,
  offset
});

export const setActiveTripPopUp = id => ({
  type: SET_ACTIVE_TRIP_POPUP,
  id
});

export const toggleActiveTripPopUp = show => ({
  type: TOGGLE_ACTIVE_TRIP_POPUP,
  show
});

export const setVehicleFilter = vehicle => ({
  type: SET_TRIP_VEHICLE_FILTER,
  vehicle
});

export const setSortFilter = sortFilter => ({
  type: SET_TRIP_SORT_FILTER,
  sortFilter
});

export const toggleShowAllTrips = show => ({
  type: TOGGLE_SHOW_ALL_TRIPS,
  show
});

export function showActiveTripPopUp(id, show) {
  return function(dispatch) {
    dispatch(setActiveTripPopUp(id));
    dispatch(toggleActiveTripPopUp(show));
  };
}

// Prod
export function fetchTrips() {
  return function(dispatch) {
    dispatch(requestTrips());
    return api
      .get(`/v1/trips?offset=0&noItems=${INITIAL_NUM_TRIPS}`)
      .then(response => {
        dispatch(receiveFeaturedPromos(response.data.banners));
        dispatch(receiveHomepageBanners(response.data.homepage_banners));
        dispatch(receiveTrips(response.data.trips, response.data.total_items));
      })
      .catch(err => {
        dispatch(receiveErrorResponse(err));
      });
  };
}

// Test
// export function fetchTrips() {
//   return function(dispatch) {
//     dispatch(requestTrips());
//     return new Promise((resolve, reject) => {
//       setTimeout(resolve, 500);
//     })
//       .then(() =>
//         dispatch(receiveTrips(fakeTripApi3.trips, fakeTripApi3.total_items))
//       )
//       .catch(err => dispatch(receiveErrorResponse(err)));
//   };
// }

export function fetchAdditionalTrips(offset, noItems) {
  return function(dispatch) {
    dispatch(requestAdditionalTrips());
    return api
      .get(`/v1/trips?offset=${offset}&noItems=${noItems}`)
      .then(response => {
        dispatch(
          receiveAdditionalTrips(response.data.trips, response.data.total_items)
        );
      })
      .catch(err => {
        dispatch(receiveErrorResponse(err));
      });
  };
}

// export function fetchAdditionalTrips(offset = 0, noItems = 4) {
//     return function(dispatch) {
//         dispatch(requestAdditionalTrips());
//         return new Promise((resolve, reject) => {
//             setTimeout(resolve, 1500);
//             //setTimeout(reject(new Error('could not receive data!')), 1000);
//         })
//         .then(() => dispatch(receiveAdditionalTrips(fakeTripApi.trips.slice(offset, offset + noItems), fakeTripApi.total_items)))
//         .catch((err) => dispatch(receiveTripsFailure(err)));
//     }
// }

// Prod
export function fetchRelatedTrips(slug, theme) {
  return function(dispatch) {
    dispatch(requestRelatedTrips());
    let apiStr = '';
    if (slug === '' || theme === '') {
      apiStr = '/v1/trips';
    } else {
      apiStr = `/v1/trips?uuidSlug=${slug}&theme=${theme}`;
    }
    return api
      .get(apiStr)
      .then(response => {
        let responseTrips = response.data.trips;
        //If it returns more than 3 trips, that means we want random trips
        if (responseTrips.length > 3) {
          responseTrips = shuffle(responseTrips).slice(0, 4);
        }
        dispatch(receiveRelatedTrips(responseTrips));
      })
      .catch(err => {
        dispatch(receiveErrorResponse(err));
      });
  };
}
